import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

interface MailboxData {
  urgentFlag: string;
  isEscalated: string;
  attchFlag: string;
  followUp: string | { flag: string };
  notesFlag: string;
  autoAssigned: string;
  suggestionIndicator?: string;
  escalationReason: string;
}

@Component({
  selector: 'app-annex-html',
  template: `
    <div class="qma-mailbox-annex-col">
      <div class="mailbox-icons-placeholder">
        <ng-container *ngFor="let item of iconsWithFlags">
          <span *ngIf="item.isVisible" class="notEmptyAnnex" 
                pTooltip="{{ item.tooltip }}" tooltipPosition="top" 
                tooltipStyleClass="leftTooltip p-tooltip-text customTooltip">
            <img [src]="item.src" [alt]="item.tooltip" />
          </span>
          <span *ngIf="!item.isVisible" class="emptyAnnex"></span>
        </ng-container>

        <span *ngIf="suggestionIcon" class="notEmptyAnnex" 
              pTooltip="Suggestion" tooltipPosition="top" 
              tooltipStyleClass="leftTooltip p-tooltip-text customTooltip">
          <img [src]="suggestionIcon" alt="Suggestion" />
        </span>
        <span *ngIf="!suggestionIcon" class="emptyAnnex"></span>
      </div>
    </div>
  `,
  styleUrls: ['./annex-html.component.scss'],
})
export class AnnexHtmlComponent {
  @Input() data!: MailboxData;
  @Input() escalationReason: string = '';

  icons = [
    { flag: 'urgentFlag', src: 'assets/Inbox/annexImp.svg', tooltip: 'Important' },
    { flag: 'isEscalated', src: 'assets/Inbox/annexAlert.svg', tooltip: 'Escalation' },
    { flag: 'attchFlag', src: 'assets/Inbox/annexAttach.svg', tooltip: 'Attachments' },
    { flag: 'followUp', src: 'assets/Inbox/annexFollowup.svg', tooltip: 'Flag' },
    { flag: 'notesFlag', src: 'assets/Inbox/annexNotes.svg', tooltip: 'Notes' },
    { flag: 'autoAssigned', src: 'assets/Inbox/auto-assign.svg', tooltip: 'Auto Assigned' },
  ];

  ngOnChanges(changes: SimpleChanges) {
    if (changes['escalationReason'] || changes['data']) {
      // Use the provided escalation reason or fallback to the one in data
      const reason = this.escalationReason || (this.data?.escalationReason || '');
      
      // Find the isEscalated icon and update its tooltip
      const escalatedIcon = this.icons.find(icon => icon.flag === 'isEscalated');
      if (escalatedIcon) {
        escalatedIcon.tooltip = reason;
      }
    }
	if (changes['data']) {
      this.updateIconsWithFlags();
    }
  }

  get suggestionIcon(): string {
    const icons: { [key: string]: string } = {
      O: 'assets/Inbox/nlp_icon_selected_u104_orange.svg',
      R: 'assets/Inbox/nlp_icon_selected_u104_red.svg',
      B: 'assets/Inbox/nlp_icon_selected_u104.svg',
      G: 'assets/Inbox/nlp_icon_selected_u104_green.svg',
    };
    return icons[this.data.suggestionIndicator || ''] || '';
  }
  
  iconsWithFlags: any[] = [];


  private updateIconsWithFlags(): void {
    this.iconsWithFlags = this.icons.map(item => ({
      ...item,
      isVisible: this.checkFlagCondition(item.flag),
    }));
  }

  private checkFlagCondition(flag: string): boolean {
    if (flag === 'followUp') {
      return (
        this.data.followUp === 'Y' ||
        (this.data.followUp && typeof this.data.followUp === 'object' && this.data.followUp.flag === 'Generic')
      );
    }
    return this.data[flag] === 'Y';
  }
}
